import { BROKER_ACTIVACION } from "../constants/permisos";
import { keyDeFactura } from "./comisionEdificiosUtil";

/**
 * Fuente ÚNICA del % de broker (segunda capa de intermediación, ver 7.13). Extraído de
 * `calcBrokerMonto` (usePublicidadCalcs.js) en Fase A2a para poder congelarlo al facturar (Fase A1+).
 *
 * El % sale de `intermediarios[cliente.broker_id].comision` resuelto **por id** (regla 10.7; hoy
 * ADLAB id 115 = 10). Gate DOBLE por fecha: requiere `broker.comision_fechainicio` Y
 * `facturaDate >= BROKER_ACTIVACION` (2026-06-01) Y `facturaDate >= broker.comision_fechainicio`;
 * si alguna no se cumple → 0. Devuelve el % **post-gate** (0 si el gate no aplica, o el % vigente).
 *
 * Shape-agnostic (patrón de resolverPorcentajeAgencia): `clientes`/`intermediarios` como ARRAY (con
 * filtro por `opp.pais`, como los pasa calcBrokerMonto) o como MAPA keyed por id (país-scopeado).
 * `facturaDate` es un Date (la fecha de factura de la venta), igual que en calcBrokerMonto.
 */
export const resolverPorcentajeBroker = (opp, clientes, intermediarios, facturaDate, pctMap = null) => {
  // A3 (7.22): % congelado si hay foto; si no, vivo (con el gate de fecha de abajo).
  const congelado = pctMap?.get(keyDeFactura(opp));
  if (congelado) return congelado.broker;
  const cliente = Array.isArray(clientes)
    ? clientes.find((c) => c.id === opp.client_id && c.pais === opp.pais)
    : clientes?.[opp.client_id];
  if (!cliente?.broker_id) return 0;
  const brokerId = parseInt(cliente.broker_id, 10);
  const broker = Array.isArray(intermediarios)
    ? intermediarios.find((i) => i.id === brokerId && i.pais === opp.pais)
    : intermediarios?.[brokerId];
  if (!broker?.comision_fechainicio) return 0;
  const activacion = new Date(BROKER_ACTIVACION);
  // Gate doble: ambas fechas deben cumplirse, si no → 0
  if (facturaDate < activacion || facturaDate < new Date(broker.comision_fechainicio)) return 0;
  return broker.comision || 0;
};
